import { Link } from 'react-router-dom';
import { linkCell } from 'utils/cell-formatter';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/fund-distributor-products' }),
  },

  {
    accessorKey: 'fund_distributor',
    header: 'Distributor',
    cell: ({ getValue }) => {
      const { short_name, id, code } = getValue();

      return (
        <Link to={`/catalog/fund-distributors/${id}`}>
          {short_name || code}
        </Link>
      );
    },
  },
  {
    accessorKey: 'fund_product',
    header: 'Product',
    cell: ({ getValue }) => {
      const { alias, id, code } = getValue();

      return (
        <Link to={`/catalog/products/funds/${id}`}>{alias || code}</Link>
      );
    },
  },
  {
    accessorKey: 'status',
    header: 'Status',
  },
];
